export default __webpack_public_path__ + "static/media/lacrosseLoadingSpinner.9be2651a.gif";